export const getUnixTimestamp = () => Math.round(Date.now() / 1000);
